import React from 'react';

import { close as closeErrorModal } from 'redux/slice/ui/ErrorModal.slice';
import { useAppDispatch } from 'utils/hooks/useAppDispatch';
import { useAppSelector } from 'utils/hooks/useAppSelector';

import ErrorModal from './ErrorModal';

const GlobalErrorModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showErrorModal, errorMessage, errorSubMessage } = useAppSelector(
    (state) => state.errorModal
  );

  const handleClose = () => dispatch(closeErrorModal());

  // Satisfy ErrorModal's setIsModalOpen signature; we just close globally
  const setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>> = () => {
    dispatch(closeErrorModal());
  };

  return (
    <ErrorModal
      isModalOpen={showErrorModal}
      setIsModalOpen={setIsModalOpen}
      message={errorMessage}
      subMessage={errorSubMessage}
      showFooter={true}
      footerProps={{ label: 'Close', onClick: handleClose }}
      fromGlobalState
    />
  );
};

export default GlobalErrorModal;
